<template>
  <div :class="['flex flex-grow', { [$style.isExpanding]: isExpanding }]">
    <div
      id="home-container"
      class="flex flex-grow overflow-auto overscroll-none"
    >
      <slot />
    </div>

    <div class="relative">
      <div ref="expander" :class="$style.expander">
        <div
          :class="[$style.innerExpander, { [$style.isExpanding]: isExpanding }]"
        />
      </div>
    </div>

    <div :class="$style.sidebar" :style="{ flexBasis: `${computedSidebarWidth}px` }">
      <slot name="sidebar" />
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { clamp } from 'lodash';
import { mapGetters } from 'vuex';

import { COOKIE_NAME_SIDEBAR_WIDTH, OUTGOING_EMAIL } from '@/constants';
import { sidebarMaxWidth, sidebarMinWidth } from '@/config';

const DEFAULT_SIDEBAR_WIDTH = 450;

let sidebarWidth =
  parseInt(Cookies.get(COOKIE_NAME_SIDEBAR_WIDTH)) || DEFAULT_SIDEBAR_WIDTH;

export default {
  name: 'PageContainer',

  data() {
    return {
      isExpanding: false,
      sidebarWidth,
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    ...mapGetters('sidebar', ['interactions']),
    computedSidebarWidth() {
      const hasOutgoingEmail = this.interactions && this.interactions.some(interaction => interaction.type === OUTGOING_EMAIL);
      if (!hasOutgoingEmail) {
        return this.sidebarWidth;
      }
      // adjust expanded width based on screen size
      let expandedWidth = 750;
      if (this.windowWidth < 1600) expandedWidth = 650;
      if (this.windowWidth < 1200) expandedWidth = 550;
      if (this.windowWidth < 992) expandedWidth = 500;
      
      return Math.max(this.sidebarWidth, expandedWidth);
    },
  },

  mounted() {
    const { expander } = this.$refs;

    expander.onmousedown = () => {
      this.isExpanding = true;

      window.onmousemove = e => {
        this.sidebarWidth = clamp(
          window.innerWidth - e.clientX,
          sidebarMinWidth,
          sidebarMaxWidth,
        );
      };
    };

    window.onmouseup = () => {
      if (this.isExpanding) {
        Cookies.set(COOKIE_NAME_SIDEBAR_WIDTH, this.sidebarWidth);

        this.isExpanding = false;

        window.onmousemove = null;
      }
    };

    // Track window resize for responsive sidebar expansion
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },

  beforeUnmount() {
    // Clean up resize listener
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
};
</script>

<style lang="scss" module>
.isExpanding {
  pointer-events: none;
}

.expander {
  cursor: ew-resize;
  display: flex;
  align-items: stretch;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 10px;
  transform: translateX(-50%);
  left: 0;
}

.innerExpander {
  width: 1px;
  background: #cbd2da;
  transition: background 200ms ease-in-out;

  &.isExpanding {
    background: #05c;
  }
}

.sidebar {
  flex-grow: 0;
  flex-shrink: 0;
  overflow: auto;
}
</style>
